export default __webpack_public_path__ + "static/IoT-integration-09778e5b70b43d8d8aa5bd0c8e41e0b5.webp";